import { createContext } from "react";

const ActivateMPContext = createContext();

export default ActivateMPContext;
